<template>
  <div class="to-guild-leader-box">
    <top-header :text="$t('guild_convert_to_diamond')" :color="'#000'"></top-header>
    <div class="can-withdrawal-box">{{ $t('guild_current_withdrawable_pcoin') }}<span>{{ currentCoin.toLocaleString('en-US') }}</span></div>
    <ul class="diamond-box hide-scrollbar ">
      <li class="diamond-item" v-for="(item,index) in configList" :key="item.configId" :class="item.configId == configInfo.configId ? 'act-diamond-item' : ''"
      @click="changeActIndex(item)">
        <div>
          <img src="../../assets/withdrawal/zuan-big.png" alt="">
        </div>
        <p>{{ item.amount }}</p>
        <p>{{ item.pocketCoin }}</p>
      </li>
    </ul>
      <div class="submit-btn" @click="submit">{{ $t('guild_appeal_to_platform') }}</div>
    <div class="loading-box" v-if="loading">
      <van-loading type="spinner" vertical />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Loading,Toast } from 'vant';
import topHeader from '@/components/withdrawal/top-header.vue';

export default {
  name: 'toguildleader',
  components: {
    topHeader,
    VanLoading: Loading
  },
  data() {
    return {
      loading: false,
      actIndex:0,
      configList: [],
      currentCoin:0,
      configId:0,
      configInfo:{}
    };
  },
  created() {
    try {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window["getUserInfo"] = (data) => {
        this.getUserInfo(data);
      };
    }catch(e){
      this.getUserInfo2();
    }
  },
  computed:{
  },
  methods: {
    getUserInfo(data){
      this.userInfo = JSON.parse(data)
      localStorage.setItem("data", JSON.stringify(this.userInfo));
      this.getUserInfo2();
    },
    // 确认转账
    submit(){
      if(Number(this.configInfo.pocketCoin) > Number(this.currentCoin)){
          return Toast(this.$t('guild_withdraw_note_2'));
      }
      this.loading = true;
      let that = this;
      axios({
        url: that.$serviceIp + `api/trade/guild/withdraw/convertDiamond`,
        method: "post",
          headers: {
            'version': '3.0',
            'deviceId': that.deviceId,
            'lang': that.lang,
          },
        data:{
          configId:that.configInfo.configId
        },
        params: { token: that.token, uid: that.uid },
      }).then((res) => {
        if (res.data.code == 200) {
            Toast(this.$t('guild_communicate_with_reseller'));
            this.initDiamondInfo()
        } else {
          Toast(res.data.message || this.$t("transfer.error"));
        }
      }).catch(()=>{}).finally(()=>{
        this.loading = false;
      });
    },
    changeActIndex(item){
      this.configInfo = item;
    },
    getUserInfo2() {
      var ids = navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
      );
      if (ids) {
        ids = ids[0];
      } else {
        ids = "Unknown Device";
      }
      let data = JSON.parse(localStorage.getItem("data"));
      this.token = data.token;
      this.uid = data.uid || data.userId;
      this.lang = data.lang || navigator.language;
      this.deviceId = data.deviceId || ids;
      let langs = this.lang.substring(0, 2);
      if (langs == "zh") {
        if (this.lang == "zh-TW" || this.lang == "zh-HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr";
      } else if (langs == "id") {
        this.$i18n.locale = "id";
      } else if (langs == "ms") {
        this.$i18n.locale = "ms";
      } else {
        this.$i18n.locale = "en";
      }
      document.title = this.$t("guild_convert_to_diamond");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
      this.initDiamondInfo();
    }, 
    // 初始化信息
    initDiamondInfo(){
      this.loading = true;
      axios
        .get(this.$serviceIp +`api/trade/guild/withdraw/convert/diamond/init?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'deviceId': this.deviceId,
                'version': '3.0',
                'lang': this.lang,
              }
        })
        .then(({data}) => {
          if (data.code == 200) {
            this.configList = data.data.configList || [];
            this.currentCoin = data.data.currentCoin;
            this.configInfo = this.configList[0];
          } else {
            Toast(data.message || this.$t("transfer.error"));
          }
        }).catch(()=>{}).finally(()=>{
          this.loading = false;
        });
    },
  }
};
</script>

<style scoped>
body {
  background-color: #f5f6f8;
  font-family: 'Mada';
}
html[lang="ar"] .to-guild-leader-box{
  direction: rtl;
}
 .to-guild-leader-box{
  background-color: #f5f6f8;
  font-family: 'Mada';
  min-height: 100vh;
 }

.can-withdrawal-box{
  font-size: 28px;
  font-weight: 400;
  color: #262427;
  text-align: center;
  margin: 26px 0;
}
.can-withdrawal-box span{
  font-weight: 700;
}
.can-withdrawal-box span::before{
  content: "";
  display: inline-block;
  width: 36px;
  height: 36px;
  background: url("../../assets/withdrawal/coin.png") no-repeat;
  background-size: 100% 100%;
  vertical-align: middle;
  margin: 4px;
}
.diamond-box{
  width: 592px;
  max-height: calc(100vh - 380px);
  overflow-y: scroll;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.diamond-item{
  margin-bottom: 22px;
  text-align: center;
  width: 284px;
  height: 252px;
  background: #fff;
  border-radius: 24px;
  padding-top: 50px;
  box-sizing: border-box;
  border: 1px solid transparent;
}
.act-diamond-item{
  border-color: #4D70FF;
}
.diamond-item img{
  display: block;
  width: 72px;
  height: 66px;
  margin: 0 auto;
}
.diamond-item p:nth-of-type(1){
  font-size: 30px;
  line-height: 40px;
  font-weight: 900;
  color: #1f1315;
  margin-top: 32px;
  margin-bottom: 8px;
}
.diamond-item p:nth-of-type(2){
  font-size: 24px;
  line-height: 32px;
  font-weight: 400;
  color: #89848D;

}
.diamond-item p:nth-of-type(2)::before{
  display: inline-block;
  content: "";
  width: 28px;
  height: 28px;
  background: url("../../assets/withdrawal/coin.png") no-repeat;
  background-size: 100% 100%;
  vertical-align: middle;
}

.submit-btn{
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 422px;
    height: 88px;
    text-align: center;
    border-radius: 44px;
    font-size: 28px;
    line-height: 88px;
    color: #fff;
    background-color: #4D70FF;
}

.loading-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
/* 隐藏滚动条 */
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.hide-scrollbar::-webkit-scrollbar {
  display: none; /* WebKit */
}
</style>